export default __webpack_public_path__ + "static/timer_animation-b0e27f5ef30f96c8b97b6ccd811b6ad5.gif";